import { render, staticRenderFns } from "./parameter1.vue?vue&type=template&id=2bddff93&scoped=true&"
import script from "./parameter1.vue?vue&type=script&lang=js&"
export * from "./parameter1.vue?vue&type=script&lang=js&"
import style0 from "./parameter1.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./parameter1.vue?vue&type=style&index=1&id=2bddff93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bddff93",
  null
  
)

export default component.exports